<template>
    <div class="">
        <custom_select
            empty_message="No venues found"
            name="selected_venue"
            no_selection_name="-- Select a venue --"
            :fixed="true"
            :prepend_selection="{label: 'All Venues', value: 'all', years: all_years}"
            :options="venues"
            :pre_selected="selected.value"
            :create_url="create_url"
            @selected="selectedEvent"
            ref="venue_select"
        ></custom_select>
    </div>
</template>

<script>
    import CustomSelectComponent from '../general_components/CustomSelectComponent.vue';
    import {venue_selection_bus} from '../../vue_components';

    export default {
    	components:{
    		'custom_select': CustomSelectComponent
        },

    	props:[
    		'venues', 'all_years', 'selected', 'create_url'
        ],

        mounted() {
    		let _this = this;

			$(document.body).data('venue-selected', this.selected.value);
			venue_selection_bus.$on('select', function (e){
				_this.$refs.venue_select.selected = e;
            });
        },

        methods: {
			selectedEvent(e){
				$(document.body).data('venue-selected', e.value);
				venue_selection_bus.$emit('select', e);
            }
        }
    }
</script>
